<div><img mat-card-image [src]="this.image" alt="Question image"></div>
